import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { AccountsTransfersStackRoutes, AccountsTransfersStackScreenProps } from './type';
import { AccountsTransfersWebOneScreen } from './AccountsTransfersWebOne.screen';
import { AccountsTransfersNativeOneScreen } from './AccountsTransfersNativeOne.screen';

export const AccountsTransfersConfirm: React.FC<AccountsTransfersStackScreenProps<AccountsTransfersStackRoutes.Confirm>> = ({
  navigation,
  route
}) => {
  const { onLayout, account, tab, data, func, onReturnData, refresh, onChangeView, record } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <AccountsTransfersNativeOneScreen
        onClose={onGoBack}
        onLayout={onLayout}
        account={account}
        tab={tab}
        data={data}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
        record={record}
      />
    );
  }

  return (
    <AccountsTransfersWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      account={account}
      tab={tab}
      data={data}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      onChangeView={onChangeView}
      record={record}
    />
  );
};
